import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { isObjectType, isInterfaceType, isInputObjectType, isEnumType, isScalarType, isUnionType } from "graphql";
import { useDocExplorerActions } from "../context.js";
/* empty css              */
function getTypeKind(type) {
  if (isObjectType(type)) {
    return "TYPE";
  }
  if (isInterfaceType(type)) {
    return "INTERFACE";
  }
  if (isInputObjectType(type)) {
    return "INPUT";
  }
  if (isEnumType(type)) {
    return "ENUM";
  }
  if (isScalarType(type)) {
    return "SCALAR";
  }
  if (isUnionType(type)) {
    return "UNION";
  }
  return "TYPE";
}
const TypeCard = (t0) => {
  const $ = c(15);
  const {
    type
  } = t0;
  const {
    push
  } = useDocExplorerActions();
  let t1;
  if ($[0] !== type) {
    t1 = getTypeKind(type);
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const kind = t1;
  let t2;
  if ($[2] !== kind || $[3] !== push || $[4] !== type) {
    const interfaces = isObjectType(type) ? type.getInterfaces() : [];
    let t3;
    if ($[6] !== kind) {
      t3 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-badge", children: kind });
      $[6] = kind;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== type.name) {
      t4 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-card-name", children: type.name });
      $[8] = type.name;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
      t5 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-type-card-header", children: [
        t3,
        t4
      ] });
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== type.description) {
      t6 = type.description && /* @__PURE__ */ jsx("p", { className: "graphiql-doc-explorer-type-card-description", children: type.description });
      $[13] = type.description;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t2 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-type-card", children: [
      t5,
      t6,
      interfaces.length > 0 && /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-type-card-implements", children: [
        /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-card-implements-keyword", children: "implements" }),
        interfaces.map((iface, i) => /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-type-card-implements-item", children: [
          i > 0 && /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-card-implements-dot", "aria-hidden": "true", children: "·" }),
          /* @__PURE__ */ jsx("a", { href: "#", className: "graphiql-doc-explorer-type-card-implements-link", onClick: (event) => {
            event.preventDefault();
            push({
              name: iface.name,
              def: iface
            });
          }, children: iface.name })
        ] }, iface.name))
      ] })
    ] });
    $[2] = kind;
    $[3] = push;
    $[4] = type;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export {
  TypeCard
};
//# sourceMappingURL=type-card.js.map
